import { BasePool } from 'core/components/reels/symbols/base/BasePool'
import { ReelSymbol } from 'core/components/reels/symbols/base/ReelSymbol'
import Container from 'core/display/Container'
import { AnimationExplosion } from 'core/display/spines/AnimationExplosion'
import { gsap, Linear, Power1 } from 'gsap'
import { ChanceManager } from 'managers/ChanceManager'
import { signal } from 'services/SignalsService'
import { explosionReelSettings, reelsSettings } from 'settings/custom/reels'
import { delay } from 'utils/Delay'

export default class ExplosionReel extends Container {
  constructor(data) {
    super()
    this.id = parseFloat(data.name.match(/\d+/))
    this.itemCount = reelsSettings.itemCount[this.id]
    this.symbolPool = new BasePool()
    this.reelItems = []
    this.spinModel = game.models.SpinModel.get()
    this.settings = null
    this.refresh = this.setSymbols

    this.createSignal()
  }

  createSignal() {
    signal.once('STATE:OUT:INIT', this.initReel.bind(this))
  }

  initReel() {
    for (let i = 0; i < this.itemCount; i++) {
      const item = new ReelSymbol(this.symbolPool)
      const itemHeight = game.models.ItemsModel.height
      this.reelItems.push(item)
      item.y = i * itemHeight
      this.addChild(item)
      const symbol = game.models.SpinModel.get().matrix[this.id][i]
      item.setSymbol(symbol)
      item.pos = i - 3
      game.models.SpinModel.setExplosionItemsSymbol(this.id, i, item)
    }
  }

  setSymbols() {
    for (let i = 0; i < this.itemCount; i++) {
      const symbol = game.models.SpinModel.get().matrix[this.id][i]
      this.reelItems[i].setSymbol(symbol)
      game.models.SpinModel.setExplosionItemsSymbol(this.id, i, this.reelItems[i])
    }
  }

  async explosion() {
    return new Promise((resolve) => {
      this.setSymbols()
      const promises = []
      this.reelItems.forEach((item, i) => {
        const anim = new Promise((resolveAnim) => {
          gsap.delayedCall(this.settings.itemDelay * i, () => {
            const animation = new AnimationExplosion(i)
            this.addChild(animation)
            gsap.to(item, 0.5, {
              alpha: 1,
              ease: Power1.easeIn,
              onComplete: () => {
                resolveAnim()
                this.removeChild(animation)
              },
            })
          })
        })
        promises.push(anim)
      })
      Promise.all(promises).then(resolve)
    })
  }

  reducer(sum, isChance) {
    return sum + (isChance ? explosionReelSettings.chance.time : this.settings.delay)
  }

  async stop() {
    await delay(this.spinModel.chance.slice(0, this.id).reduce(this.reducer.bind(this), 0))
    await ChanceManager.play(this.id)
    signal.dispatch('BEGIN-STOP-REEL', this.id)
    await this.explosion()
    signal.dispatch('END-STOP-REEL', this.id)
  }

  async start() {
    this.settings = explosionReelSettings.turbo
    return new Promise((resolve) => {
      const time = 0.3
      this.reelItems.forEach((item) => gsap.to(item, time, {
        alpha: 0,
        ease: Linear.easeNone,
        onComplete: resolve,
      }))
    })
  }
}
